<div>
	<h1 class="principal-title">Retirar efectivo</h1>
</div>
<div class="general-container">
	<div class="container-cards">
		<div [ngClass]="{ 'cards-show-code': showCode, cards: !showCode }">
			<div class="title-with-icon">
				<img src="assets/icons/cash.svg" />
				<span class="title">Efectivo</span><br />
				<img src="assets/images/rapipago-logo.png" alt="" style="margin-left: auto; display: block; margin-right: 6%" />
			</div>
			<span
				*ngIf="!showCode"
				style="font-family: 'Open Sans'; font-weight: 400; font-size: 11px; color: #5c5c5c; letter-spacing: 0.15px"
				>Comisión: {{ porcentajeComision }}% + IVA</span
			>
			<div style="margin-top: auto">
				<span style="font-size: auto"
					>Para retirar el efectivo de tu billetera/cuenta, solo tenés que acercarte a cualquier rapipago con tu DNI y el
					siguiente código</span
				>
			</div>
			<div *ngIf="showCode" class="code-bar">
				<div class="rectangulo">
					<input
						matInput
						class="input-code"
						#rapipagoIdInput
						type="text"
						value="{{ codeBar ? codeBar.slice(8) : 'Validación app necesaria' }}"
						readonly
						style="text-align: center; margin-top: 4%"
					/>
					<button *ngIf="codeBar" id="botonCopiar" mat-button (click)="copyCodeBar()">
						<mat-icon style="position: fixed">content_copy</mat-icon>
					</button>
				</div>

				<div class="max-cashin" *ngIf="codeBar">
					<span
						>Este código tiene una vigencia de <br /><br />
						<span style="font-weight: 600">30 minutos.</span> </span
					><br /><br />
					<span style="color: #FF6600; font-size: auto; font-family: 'Open Sans'; font-weight: 400"
						>Saldo disponible para retirar: {{ dispCash | currency: '$' }}</span
					><br /><br />
					<span style="font-size: auto">
						Podés retirar hasta {{ maxCash | currency: '$' }} por mes a través de este medio. El retiro tiene una comisión de
						{{ porcentajeComision }}% + IVA sobre el monto a retirar, con un mínimo de ${{ minCash }} por transacción
					</span>
				</div>
			</div>
			<div class="arrow-down" (click)="showCodeBar()">
				<mat-icon>{{ !showCode ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
			</div>
		</div>

		<div class="cards">
			<div class="title-with-icon">
				<img src="assets/icons/transfer.svg" alt="" />
				<span class="title">Transferencia</span><br />
			</div>
			<span
				style="
					font-family: 'Open Sans';
					font-size: 12px;
					font-weight: 400;
					line-height: 24px;
					letter-spacing: 0.15px;
					margin-top: 0px;
					margin-bottom: 20px;
				"
			>
				<span style="color: #FF6600">Gratis </span><span style="color: #cccccc">| instantánea</span>
			</span>
			<div>
				<span>Podés transferir tu dinero a otra cuenta personal o ajena.</span>
			</div>
			<div class="arrow-down" (click)="navigate('/user/cashout/transfer')">
				<mat-icon>arrow_right_alt</mat-icon>
			</div>
		</div>
	</div>
</div>
